import { NgModule } from "@angular/core";
import { PushMessageComponent } from "./pushMessageComponent";
import { FormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { UiElementComponent } from "./uiElementComponent";
import { PopupModule, TextBoxModule, CheckboxModule, ImageModule } from "../../../../shared/components";
import { SelectModule } from "../../../../shared/components/select";


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PopupModule,
    SelectModule,
    TextBoxModule,
    CheckboxModule,
    ImageModule
    //SafeHtmlModule
  ],
  declarations: [
    PushMessageComponent,
    UiElementComponent
  ],
  providers: [
  ],
  exports: [
    PushMessageComponent,
    UiElementComponent
  ]  
})
export class PushMessageModule {

}